const MESSAGES = {
  400: "Bad request error: Malformed request object.",
  401: "Unauthorized error: Access is denied due to invalid credentials.",
  403: "Forbidden error: You do not have enough permissions to view this page.",
  404: "Resource not found: The webpage you are trying to load could not be found on the server.",
  500: "Internal server error: Oops! Something happened to our servers, Try again.",
  default: "Try this request again."
};

export default MESSAGES;
